"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchBar = void 0;
const react_1 = require("react");
const useSearchBar = (props) => {
    const { activeQuery, onSearch, disabled } = props;
    const [isFocused, setIsFocused] = react_1.useState(false);
    const [isDirty, setIsDirty] = react_1.useState(false);
    const [query, setQuery] = react_1.useState('');
    const handleSearch = (q) => {
        setIsDirty(false);
        setIsFocused(false);
        onSearch(q);
    };
    const handleFocus = react_1.useCallback((event) => {
        event.target.select();
        setIsFocused(true);
    }, []);
    const handleBlur = react_1.useCallback(() => {
        if (!isDirty) {
            setIsFocused(false);
        }
    }, [isDirty]);
    const handleChange = react_1.useCallback((event) => {
        setIsDirty(true);
        setQuery(event.target.value);
    }, []);
    const handleEnterPress = react_1.useCallback((event) => {
        if (event.key === 'Enter') {
            handleSearch(query);
        }
    }, [query]);
    const handleSubmitClick = react_1.useCallback(() => {
        handleSearch(query);
    }, [query]);
    const handleResetClick = react_1.useCallback(() => {
        handleSearch('');
        setQuery('');
    }, []);
    const value = isFocused || disabled ? query : activeQuery;
    return {
        handleFocus,
        handleBlur,
        handleChange,
        handleEnterPress,
        handleSubmitClick,
        handleResetClick,
        value,
        isFocused,
        disabled
    };
};
exports.useSearchBar = useSearchBar;
//# sourceMappingURL=useSearchBar.js.map